export default {
  kls_user_session(state) {
    return state.user_info.session_key
  },
  // 获取当前播放的视频的vod_id
  play_vod_id(state){
    return state.video.play_vod_id
  },
  user_info(state) {
    return state.user_info
  },
  user_id(state, getters) {
    return getters.user_info.uid
  },
  user_phone(state, getters) {
    return getters.user_info.login_phone
  },
  user_email(state, getters) {
    return getters.user_info.login_email
  },
  user_name(state, getters) {
    return getters.user_info.user_name
  },
  user_role(state, getters) {
    return getters.user_info.role_list
  },
  user_avatar(state, getters) {
    return getters.user_info.user_avatar
  },
  // current_session_list(state) {
  //     return state.current_event.t_session
  // },
  get_lang(state) {
    return state.lang
  },
  get_ajax_count(state) {
    return state.ajax_spin_count
  },
  get_current_session_id(state) {
    return state.current_session_id
  },
  get_current_session_status(state) {
    return state.current_session_status
  },
  get_current_role(state){
    return state.current_role
  },
  get_current_event_id(state){
    return state.current_event_id
  },
  get_assistant_temp_session(state){
    return state.assistant_temp_session
  },
  get_place_map(state){
    return state.place_map
  },
  get_current_identify(state){
    return state.current_identify
  },
  get_identify_list(state){
    return state.user_identify
  },
  // 获取全部的未读数
  get_unread_by_total(state){
    return state.unread.total_count
  },
  //获取系统消息未读数
  get_unread_by_in_station(state){
    return state.unread.in_station_count
  },
  //获取活动消息未读数
  get_unread_by_active(state){
    return state.unread.active_count
  },
  // 获取会议消息未读数
  get_unread_by_session(state){
    return state.unread.session_count
  },
  // 获取运动消息未读数
  get_unread_by_sport(state){
    return state.unread.sport_count
  },
  // 获取运动项目消息未读数
  get_unread_by_activity(state){
    return state.unread.activity_count
  },
  get_current_event(state){
    return state.current_event
  }
}



// WEBPACK FOOTER //
// ./src/store/getters.js